import { atom } from "recoil"

export const matchingOfferDetailRequestIdState = atom({
  key: "atoms/matching/matchingOfferDetailRequestIdState",
  default: 0,
})
